import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { GroupService } from '../services/group.service';
import { PlayerService } from '../services/player.service';

/**
 * Shared guard that prevents non-admin players from accessing admin routes.
 * Checks if the logged-in player is admin of at least one group.
 * Redirects to /dashboard if not authorized.
 */
@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {

  constructor(
    private playerService: PlayerService,
    private groupService: GroupService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const player = this.playerService.getLoggedInPlayerInfo();
    if (!player) {
      this.router.navigateByUrl('/login');
      return false;
    }

    const adminGroups = this.groupService.getAdminGroups();
    if (!adminGroups || adminGroups.length === 0) {
      this.router.navigateByUrl('/dashboard');
      return false;
    }

    return true;
  }
}
